export function renameDefaultFilenames(anexos: {
  [key: string]: File[];
}): File[] {
  let tipoArquivos = Object.keys(anexos);
  let files: File[] = [];

  tipoArquivos.forEach((tipoArquivo) => {
    for (let i = 0; i < anexos[tipoArquivo].length; i++) {
      var splitName = anexos[tipoArquivo][i].name.split('.');
      var extension = splitName[splitName.length - 1];
      var sequence = (i + 1).toString().padStart(2, '0');
      var fileName = `${tipoArquivo}_${sequence}.${extension}`;
      files.push(
        new File([anexos[tipoArquivo][i]], fileName, {
          type: anexos[tipoArquivo][i].type,
        })
      );
    }
  });

  return files;
}
